import React, { FC } from 'react';

import { TransactionProject } from '../../../../api-client';
import { cn, resultIf } from '../../../../utils';
import { ChevronIcon, MultiSelect } from '../../../common';
import { MultiSelectContext } from '../../../common/selects/MultiSelect/MultiSelectContext';

import './TransactionsProjectSelect.scoped.scss';

interface Props {
  projects: Array<TransactionProject>;
  selectedProjects: Array<TransactionProject>;
  onSelected: (projects: Array<TransactionProject>) => void;
}

const TransactionsProjectSelect: FC<Props> = ({ projects, selectedProjects, onSelected }) => {
  return (
    <div className="transactions-project-select">
      <MultiSelect
        options={projects}
        selectedOptions={selectedProjects}
        renderOption={(item: TransactionProject) => item.projectName}
      >
        <MultiSelect.Head className="transactions-project-select__header">
          <MultiSelectContext.Consumer>
            {({ active, selectedOptions }) => (
              <>
                {/*{selectedProjects[1] ? selectedProjects[1] : "Проекты"}*/}
                <div className="transactions-project-select__heading">
                  {selectedOptions.length === 0
                    ? 'Проекты'
                    : `Выбрано ${selectedOptions.length} проектов`}
                </div>
                <ChevronIcon
                  direction="down"
                  color="var(--black-color)"
                  className={cn('transactions-project-select__image', resultIf(active, 'active'))}
                  title="Раскрыть список"
                />
              </>
            )}
          </MultiSelectContext.Consumer>
        </MultiSelect.Head>
        <MultiSelect.Content
          className="transactions-project-select__content"
          onSelected={onSelected}
        />
      </MultiSelect>
    </div>
  );
};

export default TransactionsProjectSelect;
